"use strict";
// Copyright © 2021 Move Closer
Object.defineProperty(exports, "__esModule", { value: true });
exports.HR_RULES = void 0;
const _abstract_1 = require("../_abstract");
/**
 * Set of rules (constraints) associated with the `HRToken`.
 *
 * @author Stanisław Gregor <stanislaw.gregor@movecloser.pl>
 */
exports.HR_RULES = _abstract_1.generateRules({
    pl: [
        'Ilość znaków [-] MUSI być większa lub równa 3'
    ]
});
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiaHIucnVsZXMuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi9zcmMvdG9rZW5pemVycy9oci9oci5ydWxlcy50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiO0FBQUEsK0JBQStCOzs7QUFFL0IsNENBQTREO0FBRTVEOzs7O0dBSUc7QUFDVSxRQUFBLFFBQVEsR0FBbUIseUJBQWEsQ0FBQztJQUNwRCxFQUFFLEVBQUU7UUFDRiwrQ0FBK0M7S0FDaEQ7Q0FDRixDQUFDLENBQUEiLCJzb3VyY2VzQ29udGVudCI6WyIvLyBDb3B5cmlnaHQgwqkgMjAyMSBNb3ZlIENsb3NlclxuXG5pbXBvcnQgeyBUb2tlbml6ZXJSdWxlcywgZ2VuZXJhdGVSdWxlcyB9IGZyb20gJy4uL19hYnN0cmFjdCdcblxuLyoqXG4gKiBTZXQgb2YgcnVsZXMgKGNvbnN0cmFpbnRzKSBhc3NvY2lhdGVkIHdpdGggdGhlIGBIUlRva2VuYC5cbiAqXG4gKiBAYXV0aG9yIFN0YW5pc8WCYXcgR3JlZ29yIDxzdGFuaXNsYXcuZ3JlZ29yQG1vdmVjbG9zZXIucGw+XG4gKi9cbmV4cG9ydCBjb25zdCBIUl9SVUxFUzogVG9rZW5pemVyUnVsZXMgPSBnZW5lcmF0ZVJ1bGVzKHtcbiAgcGw6IFtcbiAgICAnSWxvxZvEhyB6bmFrw7N3IFstXSBNVVNJIGJ5xIcgd2nEmWtzemEgbHViIHLDs3duYSAzJ1xuICBdXG59KVxuIl19